export const SUPPORT_EMAIL = "support@haulbase.ai";
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;

export const SUPPORT_LINKS = [
  { label: "Email support", href: SUPPORT_MAILTO, status: "active" },
  { label: "Docs", href: "https://haulbase.ai/docs", status: "tbd" },
  { label: "Slack Connect", href: SUPPORT_MAILTO, status: "customer_specific" },
] as const;
